module.exports = __webpack_public_path__ + "img/card.897f9847.svg";